import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { authSelectors } from '../../store/selectors/auth';
import { profileSelectors } from '../../store/selectors/profile';
import { noticesPreview } from '../../api/notices';
import { CalendarIcon } from '../CalendarPromo/CalendarPromoModal';
import ModalInfo from './ModalInfo';

import '../CalendarPromo/calendar-promo.style.scss';
import './popup-preview.scss';

const BODY_CLASS = 'popup-preview-open';

const CalendarPreview = ({ item, onNext }) => {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <div className="cpromo popup-preview__cpromo" role="dialog" aria-modal="true" aria-label={item.title || item.label}>
      <div className="cpromo__overlay" onClick={onNext} aria-hidden="true" />
      <div className="cpromo__box">
        <button type="button" className="cpromo__close" onClick={onNext} aria-label="Закрити">✕</button>
        {item.image && !imageFailed ? (
          <img className="cpromo__image" src={item.image} alt="" onError={() => setImageFailed(true)} />
        ) : (
          <div className="cpromo__icon"><CalendarIcon /></div>
        )}
        {item.title && <h3 className="cpromo__title">{item.title}</h3>}
        {item.text && <div className="cpromo__text" dangerouslySetInnerHTML={{ __html: item.text }} />}
        <div className="cpromo__btns">
          {item.primary_button && (
            <button type="button" className="cpromo__btn cpromo__btn--main" onClick={onNext}>{item.primary_button}</button>
          )}
          {item.secondary_button && (
            <button type="button" className="cpromo__btn cpromo__btn--ghost" onClick={onNext}>{item.secondary_button}</button>
          )}
        </div>
      </div>
    </div>
  );
};

CalendarPreview.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.string,
    primary_button: PropTypes.string,
    secondary_button: PropTypes.string,
  }).isRequired,
  onNext: PropTypes.func.isRequired,
};

const BirthForm = ({ onNext }) => (
  <div className="modal-info-birth-date">
    <label className="modal-info-birth-date__label">Дата народження</label>
    <input name="birth_date" type="date" className="modal-info-birth-date__input" />
    <button type="button" className="modal-info-birth-date__button" onClick={onNext}>Зберегти</button>
  </div>
);

BirthForm.propTypes = {
  onNext: PropTypes.func.isRequired,
};

const PopupPreview = () => {
  const auth = useSelector(authSelectors);
  const profile = useSelector(profileSelectors);
  const token = auth.token;
  const isTestStudent = Boolean(profile?.user?.is_test_student);

  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);
  const requested = useRef(null);

  useEffect(() => {
    if (!token || !isTestStudent || requested.current === token) {
      return undefined;
    }

    requested.current = token;
    let cancelled = false;

    noticesPreview({ token })
      .then((response) => {
        const list = response?.data?.data?.items;

        if (!cancelled && Array.isArray(list) && list.length > 0) {
          setItems(list);
          setIndex(0);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [token, isTestStudent]);

  const item = items[index] || null;

  useEffect(() => {
    document.body.classList.toggle(BODY_CLASS, Boolean(item));

    return () => document.body.classList.remove(BODY_CLASS);
  }, [item]);

  if (!item) {
    return null;
  }

  const next = () => setIndex((value) => value + 1);
  const finish = () => setIndex(items.length);
  const isLast = index === items.length - 1;

  return (
    <div className="popup-preview">
      <div className="popup-preview__bar" role="status">
        <span className="popup-preview__count">Перегляд вікон · {index + 1} з {items.length}</span>
        <span className="popup-preview__label">{item.label}</span>
        <span className="popup-preview__actions">
          <button type="button" className="popup-preview__btn popup-preview__btn--main" onClick={next}>
            {isLast ? 'Готово' : 'Далі →'}
          </button>
          {!isLast && (
            <button type="button" className="popup-preview__btn" onClick={finish}>Завершити</button>
          )}
        </span>
      </div>

      {item.kind === 'calendar' ? (
        <CalendarPreview key={index} item={item} onNext={next} />
      ) : (
        <ModalInfo
          key={index}
          notification={{ title: item.title, text: item.text, button: item.button, image: item.image }}
          setOpenModal={next}
          openModal={true}
          closeOnPrimaryClick={true}
        >
          {item.kind === 'birth' ? <BirthForm onNext={next} /> : null}
        </ModalInfo>
      )}
    </div>
  );
};

export default PopupPreview;
